import { MyRacAuthProps } from "raci-react-library";
import {
  ADB2C_CLIENT_ID,
  ADB2C_DOMAIN,
  ADB2C_RETURN_URL,
  ADB2C_TENANT,
  SILENT_LOGIN_REDIRECT_URL,
} from "../../constants";
import useMyRacLogin from "../../hooks/useMyRacLogin";
import getPageTemplateBannerAndButtons from "../../hooks/usePage/getPageTemplateBannerAndButtons";

export const racwaAuthProps = {
  clientId: ADB2C_CLIENT_ID,
  tenant: ADB2C_TENANT,
  domain: ADB2C_DOMAIN,
};

export const getMyRacAuthProps = (): Omit<MyRacAuthProps, "children"> => ({
  clientId: ADB2C_CLIENT_ID,
  silentLoginRedirectUrl: SILENT_LOGIN_REDIRECT_URL,
  loginRedirectUrl: ADB2C_RETURN_URL,
  useMyRacLogin: useMyRacLogin,
  requireLogin: true,
  productLinkingErrorProps: getPageTemplateBannerAndButtons(),
});
